import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../../../../constants/event-items';
import EventAddonItemBlock from '../FreemiumEventCreateSKUSelectionStep/components/EventAddonItemBlock';
import { ALBUM_SUBTYPE } from '../../../../../../../constants/albums';
import WaldoSpeechBubble from '../../../../../../../components/global/WaldoSpeechBubble';
import { getAsset } from '../../../../../../../util/assets';

const propTypes = {
  setStepProps: PropTypes.func.isRequired,
  stepProps: PropTypes.shape({
    eventAddonItems: PropTypes.func,
    onEventAddonItemToggle: PropTypes.func,
    currentSelectedEventAddonItemIds: PropTypes.arrayOf(PropTypes.string),
  }),
  handleChange: PropTypes.func,
  promoCode: PropTypes.string,
};

const FreemiumEventCreateUpgradeBundleStep = ({
  stepProps,
  setStepProps,
  handleChange,
  promoCode = 'PLATINUM3FOR2',
}) => {
  const {
    eventType,
    shouldUseIOSBundles,
    eventAddonItems,
    iOSEventAddonItemsBundle,
    currentSelectedEventAddonItemIds,
    setSelectedEventAddonItemIds,
  } = stepProps;

  const availableEventAddonItems = eventAddonItems.filter(
    item =>
      item.types.length === 2 &&
      [
        EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK,
        EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO,
      ].includes(item.types[0]),
  );
  const waldofiedEventAddonItem = eventAddonItems.find(
    item =>
      item.types.length === 1 &&
      item.types.includes(EVENT_ADDON_ITEM_TYPE.WALDOFIED),
  );
  const completeBundleEventAddonItem = shouldUseIOSBundles
    ? iOSEventAddonItemsBundle
    : eventAddonItems.find(
        item =>
          item.types.includes(EVENT_ADDON_ITEM_TYPE.WALDOFIED) &&
          item.types.includes(EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK) &&
          item.types.includes(EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO),
      );

  const groupVideoTitle = useMemo(() => {
    if ([ALBUM_SUBTYPE.WEDDINGS, ALBUM_SUBTYPE.MEMORIALS].includes(eventType)) {
      return 'Video Guestbook';
    }

    return 'Group Video';
  }, [eventType]);

  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        <WaldoSpeechBubble
          className="freemium-create-wizard-bubble"
          position="right"
        >
          Make your event more memorable with a Memories Slideshow and a{' '}
          {groupVideoTitle}
        </WaldoSpeechBubble>
        <div className="freemium-create-wizard-bundle-notice">
          <img
            src={getAsset('/gift-discount.svg')}
            width="38px"
            height="38px"
            className="mr-2"
            alt="Gift"
          />
          <p className="text-primary text-extra-bold mb-0">
            Limited offer: Get two premium albums for the price of one! <br />
            <span className="text-light text-sm text-normal">
              Eligible when purchased with Gold.
            </span>
          </p>
        </div>
        <div>
          {availableEventAddonItems.map(eventAddonItem => {
            return (
              <EventAddonItemBlock
                key={eventAddonItem.id}
                onToggle={() => {
                  const bundleSelected =
                    currentSelectedEventAddonItemIds.includes(
                      completeBundleEventAddonItem.id,
                    );
                  if (!shouldUseIOSBundles) {
                    handleChange({
                      target: {
                        name: 'promo_code',
                        value: bundleSelected ? '' : promoCode,
                      },
                    });
                  }
                  if (bundleSelected) {
                    setSelectedEventAddonItemIds([waldofiedEventAddonItem.id]);
                  } else {
                    setSelectedEventAddonItemIds([
                      completeBundleEventAddonItem.id,
                    ]);
                  }
                  if (!stepProps.upgradeStepCompleted) {
                    setStepProps({
                      ...stepProps,
                      upgradeStepCompleted: true,
                    });
                  }
                }}
                isSelected={currentSelectedEventAddonItemIds.includes(
                  completeBundleEventAddonItem.id,
                )}
                eventAddonItem={eventAddonItem}
                eventType={eventType}
                itemStyle="bundle"
              />
            );
          })}
        </div>
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

FreemiumEventCreateUpgradeBundleStep.propTypes = propTypes;

export default FreemiumEventCreateUpgradeBundleStep;
